export class Search {
	static readonly type = '[condoCorporationManagementSearch] search';
	constructor(public searchTerm: string) {}
}
